import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mb-20" }
const _hoisted_2 = { class: "mt-60 mb-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileInfo = _resolveComponent("ProfileInfo")!
  const _component_ProfilePassword = _resolveComponent("ProfilePassword")!
  const _component_ProfileAddress = _resolveComponent("ProfileAddress")!
  const _component_ProfileDelete = _resolveComponent("ProfileDelete")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.labels.myInformationHeading), 1),
    _createVNode(_Transition, {
      name: "o-anim-fade-300",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock("div", { key: _ctx.editModeAnimationKey }, [
          (!_ctx.isPasswordEditMode)
            ? (_openBlock(), _createBlock(_component_ProfileInfo, {
                key: 0,
                "confirm-email-settings": _ctx.confirmEmailSettings
              }, null, 8, ["confirm-email-settings"]))
            : _createCommentVNode("", true),
          (!_ctx.isInformationEditMode)
            ? (_openBlock(), _createBlock(_component_ProfilePassword, {
                key: 1,
                class: "max-w-500"
              }))
            : _createCommentVNode("", true)
        ]))
      ]),
      _: 1
    }),
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.labels.myAddressHeading), 1),
    _createVNode(_component_ProfileAddress, { countries: _ctx.countries }, null, 8, ["countries"]),
    _createVNode(_component_ProfileDelete, { class: "mt-50" })
  ]))
}